import React from 'react';
import { ConfigProvider, Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import { AdminLayoutProvider } from '@/context/AdminLayoutContext';
import Header from './Header';
import styles from './AdminUserAppLayout.module.pcss';

const { Content } = Layout;

export default function AdminLayout() {
  return (
    <AdminLayoutProvider>
      <ConfigProvider
        theme={{
          token: {
            fontFamily: 'Inter',
            colorPrimary: '#202020',
          },
          components: {
            Statistic: {
              fontFamily: 'CodecPro-ExtraBold',
            },
            Select: {
              optionSelectedBg: '#A1ABB7',
            },
            Button: {
              primaryShadow: '0 0px 0 rgba(0, 0, 0, 0.62)',
            },
            Table: {
              headerColor: '#6B7280',
              headerBg: '#F9FAFB',
              colorBgContainer: '#fff',
              borderRadius: 10,
              padding: 16,
              rowHoverBg: 'var(--hover-color, #fafafa)',
              rowSelectedBg: 'var(--selected-color, #F1F5F9)',
              rowSelectedHoverBg: 'var(--selected-color, #e6f7ff)',
              borderColor: 'var(--border-color, #f0f0f0)',
              fontSize: 14,
              headerSplitColor: 'var(--border-color, #f0f0f0)',
              headerBorderRadius: 10,
              cellPaddingBlock: 16,
              cellPaddingInline: 16,
            },
          },
        }}
      >
        <Layout className={styles.root}>
          <Header />
          <Content className={styles.content}>
            <Outlet />
          </Content>
        </Layout>
      </ConfigProvider>
    </AdminLayoutProvider>
  );
}
